var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delivery-form',{attrs:{"allow-first-date-selection":true,"enable-delivery-waiting-list":false,"enable-incomplete-registration":true}})}
var staticRenderFns = []

export { render, staticRenderFns }